module.exports = __webpack_public_path__ + "img/Rogue-bloodelf-m-70.0cc70d56.gif";